import { initCurrentMedia } from 'redux/currentMedia/actions'
import { initNavigation } from 'redux/navigation/actions'
import { INIT_MEDIA_LIST } from 'redux/mediaList/actions'
import { getGroupPosition } from 'redux/navigation/selectors'
import { getMediaList } from 'redux/mediaList/selectors'

export function applyStateFromHistory(state) {
    return function applyStateFromHistory(dispatch, getState) {

        const pushToHistory = false
        const groupPosition = getGroupPosition(getState())

        dispatch(initCurrentMedia(state.currentMedia, pushToHistory))
        dispatch(initNavigation(state.navigation))

        if(getGroupPosition(state) !== groupPosition)
        {
            return dispatch({type: INIT_MEDIA_LIST, mediaList: getMediaList(getState())})
        }
    }
}
